export class ResponsePrivateTour {
  status: boolean;

  message: string;

  code: string;

  data: string;

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.data = res?.data || "";
    this.code = res?.code || "";
  }
}
export interface PrivateTourParams {
  email: string;
  tel: string;
  description: string;
}
